export default __webpack_public_path__ + "static/media/herobg.84b92515.mp4";